export default "__VITE_ASSET__DkES5rwy__"